module.exports = __webpack_public_path__ + "img/icon-sleep-time-2.8dd7777a.svg";